export const PREMIUM_SIZE = {
	value: "PREMIUM_SIZE",
	key:
	  "clients.client.categorisation.categoryForm.form.vipClassificationTypes.premiumSize",
  };
  
  export const PARTNER = {
	value: "PARTNER",
	key:
	  "clients.client.categorisation.categoryForm.form.vipClassificationTypes.partner",
  };
  
  export const NETWORK = {
	value: "NETWORK",
	key:
	  "clients.client.categorisation.categoryForm.form.vipClassificationTypes.network",
  };
  
  export const ACQUAINTANCE = {
	value: "ACQUAINTANCE",
	key:
	  "clients.client.categorisation.categoryForm.form.vipClassificationTypes.acquaintance",
  };
  
  export default [PREMIUM_SIZE, PARTNER, NETWORK, ACQUAINTANCE];
  


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/categorisation/enums/categorisationVIPClassificationTypes.js